<template>
    <item :title="title" :subTitle="subtitle" iconClass="ogc-icon-qiye" :isActive="isActive">
        <template slot="buttons">
            <el-button class="button" type="primary" round plain @click="onShow">{{ button }}</el-button>
        </template>

        <fc-dialog :title="button" :visible.sync="visible">

            <el-alert v-if="state == 0" title="您尚未申请企业认证，请填写企业信息，保存且经过审批后，即可升级为企业客户！" type="info"></el-alert>
            <el-alert v-if="state == 1" title="企业信息审批中，请耐心等待..." type="warning"></el-alert>
            <el-alert v-if="state == 2" title="恭喜，企业认证成功！您现在已升级为企业客户！" type="success"></el-alert>
            <el-alert v-if="state == 9" title="很遗憾，您提交的企业资料未通过我们的审批，请您修改之后重新提交，我们会尽快为您处理。" type="error"></el-alert>

            <auto-form ref="form" :rules="rules" :form="form" :form-template="formTemplate" :url="url.save"
                @beforeSave="beforeSave" @afterSaved="afterSaved" @saved="onSaved" :canEdit="state == 0" :isEdit="false"></auto-form>

            <div slot="footer" class="dialog-footer">
                <template v-if="state == 0">
                    <el-button type="warning" :disabled="uploading" plain @click="cancel"> 取 消 </el-button>
                    <el-button type="success" :disabled="uploading" @click="save"> 确 认 </el-button>
                </template>
                <template v-else>
                    <el-button type="success" :disabled="uploading" @click="cancel"> 确 认 </el-button>
                </template>
            </div>
        </fc-dialog>
    </item>
</template>

<script type="text/javascript">

import AutoForm from '@/components/AutoForm'
import FcDialog from '@/components/Dialogs/Dialog'
import Item from './OptionItem'

export default {
    components: {
        AutoForm, FcDialog, Item
    },
    props: {
        company: {
            type: String,
            default: null
        },
        CompanyState:{
          type: Number,
          default: null
        }
    },
    data() {
      // 银行卡号
      let validateBankcard2 = (rule, value, callback) => {
        if(!this.formChange.Account) {
          callback();
        // }
        // else if (!this.bankIsOk) {
        //   callback(new Error('您输入的银行卡号暂不支持！'));
        } else {
          validateBankcard(rule, value, callback);
        }
      }

      // 营业执照
      let validateBusinessLicense = (rule, value, callback) => {
        var reg = /(^(?:(?![IOZSV])[\dA-Z]){2}\d{6}(?:(?![IOZSV])[\dA-Z]){10}$)|(^\d{15}$)/;
        if(!this.formChange.BusinessLicense) {
          callback();
        }
        else if (!reg.test(value)) {
          callback(new Error('您输入正确的营业执照！'));
        } else {
          callback();
        }
      }

      // 法人
      let validateJuridicalPerson = (rule, value, callback) => {
        if(!this.formChange.JuridicalPerson) {
          callback();
        }
        else if (value.length > 5) {
          callback(new Error('长度不能超过 5 个字符'));
        } else {
          callback();
        }
      }

      // 税号
      let validateDutyParagraph = (rule, value, callback) => {
        var reg = /^[A-Z0-9]{15}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/;
        if(!this.formChange.DutyParagraph) {
          callback();
        }
        else if (!reg.test(value)) {
          callback(new Error('您输入正确的税号！'));
        } else {
          callback();
        }
      }

      // 电话
      let validatePhone2 = (rule, value, callback) => {
        var reg = /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/;
        if(!this.formChange.Phone) {
          callback();
        }
        else if (!reg.test(value)) {
          callback(new Error('您输入号码格式不正确或者位数不正确！'));
        } else {
          callback();
        }
        /*else {
          validatePhone(rule, value, callback);
        }*/
      }

      // 传真
      let validateFax= (rule, value, callback) => {
        if(!this.formChange.Fax) {
          callback();
        }
        else if (value.length > 20) {
          callback(new Error('长度不能超过 20 个字符'));
        } else {
          callback();
        }
      }

      // 邮编
      let validateZipCode= (rule, value, callback) => {
        if(!this.formChange.ZipCode) {
          callback();
        }
        else if (value.length > 50) {
          callback(new Error('长度不能超过 50 个字符'));
        } else {
          callback();
        }
      }
        return {
            visible: false,
            state: 9,
            form:{
                Account:'', Bank:'', Province:'', City:'', AccountBank:'',
                Adress: null, ApprovaledTime: null, Area: null, BusinessLicense: null, Code: null, OnlyBusinessLicense: true,
                DutyParagraph: null, EnglishName: null, Fax: null, JuridicalPerson: null, Name: null,
                Phone: null, Remark: null, SimpleName: null, ZipCode: null
            }, 
            rules: {
              Name :[
                { required: true, message: '请输入企业名称', trigger: 'blur' },
                {  max: 200, message: '长度不能超过 200 个字符', trigger: 'blur' }
              ],
              SimpleName :[
                {  max: 50, message: '长度不能超过 50 个字符', trigger: 'blur' }
              ],
              EnglishName :[
                {  max: 500, message: '长度不能超过 500 个字符', trigger: 'blur' }
              ],
              Code :[
                {  max: 50, message: '长度不能超过 50 个字符', trigger: 'blur' }
              ],
              BusinessLicense :[
                { required: true, message: '请输入营业执照', trigger: 'blur' },
                {
                  validator: validateBusinessLicense,
                  trigger: 'blur'
                }
              ],
              JuridicalPerson:[
                { required: true, message: '请输入法人', trigger: 'blur' },
                {
                  validator: validateJuridicalPerson,
                  trigger: 'blur'
                }
              ],
              DutyParagraph:[
                { required: true, message: '请输入税号', trigger: 'blur' },
                {
                  validator: validateDutyParagraph,
                  trigger: 'blur'
                }
              ],
              OnlyBusinessLicense :[
                { required: true, message: '请选择三证合一', trigger: 'change' }
              ],
              Phone :[
                {
                  required: true,
                  message: '请输入电话',
                  trigger: 'blur'
                },
                {
                  validator: validatePhone2,
                  trigger: 'blur'
                }
              ],
              Fax :[
                {
                  validator: validateFax,
                  trigger: 'blur'
                }
              ],
              ZipCode :[
                {
                  validator: validateZipCode,
                  trigger: 'blur'
                }
              ],
              Area:[
                {  max: 10, message: '长度不能超过 10 个字符', trigger: 'blur' }
              ],
              Account:[
                {
                  required: true,
                  message: '请输入银行账号',
                  trigger: 'blur'
                },
                {
                  validator: validateBankcard2,
                  trigger: 'blur'
                }
              ],
              Bank: [{ required: true, message: '请选择开户行', trigger: 'change' }],
              Province: [{ required: true, message: '请选择开户行所在省份', trigger: 'change' }],
              City: [{ required: true, message: '请选择开户行所在城市', trigger: 'change' }],
              AccountBank: [{ required: true, message: '请选择开户银行支行', trigger: 'change' }],
            }, 
            formTemplate:[
                { col:24, type: 'tips', tips:'企业基本信息' },
                { col:12, label:'企业名称', prop:'Name' },
                { col:12, label:'企业简称', prop:'SimpleName' },
                { col:12, label:'英文名称', prop:'EnglishName' },
                { col:12, label:'企业编码', prop:'Code' },
                { col:24, type: 'tips', tips:'企业注册信息' },
                { col:12, label:'营业执照', prop:'BusinessLicense', change:(v)=>{this.BusinessLicenseChange(v)} },
                { col:12, label:'法人', prop:'JuridicalPerson' ,change:(v)=>{this.JuridicalPersonChange(v)}},
                { col:12, label:'税号', prop:'DutyParagraph' ,change:(v)=>{this.DutyParagraphChange(v)}},
                { col:12, label:'三证合一', prop:'OnlyBusinessLicense', type: 'radio',
                options: [
                    { label: '是', value: true },
                    { label: '否', value: false }
                ], default: true },
                { col:12, label:'手机号', prop:'Phone',change:(v)=>{this.PhoneChange(v)} },
                { col:12, label:'传真', prop:'Fax',change:(v)=>{this.FaxChange(v)} },
                { col:12, label:'地区编码', prop:'Area' },
                { col:12, label:'邮编', prop:'ZipCode',change:(v)=>{this.ZipCodeChange(v)} },
                { col:24, label:'注册地址', prop:'Adress' },
                { col:24, type: 'tips', tips:'企业账户信息' },
                { col: 24, label: '银行账号', prop: 'Account', change: (v) => { this.onAccountChange(v); } }, // 26
                { col: 24, label: '开户银行', prop: 'Bank', type: 'select', options: [], change: () => { this.loadBankBranch(); }, filterable: true }, // 23
                { col: 12, label: '开户省份', prop: 'Province', type: 'select', options: [], change: () => { this.loadCity(); }, filterable: true }, // 24
                { col: 12, label: '开户地级市', prop: 'City', type: 'select', options: [], change: () => { this.loadBankBranch(); }, filterable: true }, // 25
                { col: 24, label: '开户银行支行', prop: 'AccountBank', type: 'select', options: [], filterable: true }, // 26
                { col:24, type: 'tips', tips:'其他信息' }, // 31
                { col:24, label:'备注', prop:'Remark', type: 'textarea' } // 32
            ],
            url: {
                province: SZH.assets.api + "/Market/GetSelectProvince",
                city: SZH.assets.api + "/Market/GetSelectCity",
                bank: SZH.assets.api + "/Market/GetSelectBaseBank",
                bankBranch: SZH.assets.api + "/Market/GetSelectBankInfo",
                bankSearch: SZH.assets.api + "/Market/GetBankMapping",

                get: SZH.assets.api + '/Custom/GetCompanyInfo',
                save: SZH.assets.api + '/Custom/SaveCustomEnterprise',
            },
            formChange: {
              Account:false, // 银行卡号
              BusinessLicense: false, // 营业执照
              JuridicalPerson:false, // 法人
              DutyParagraph:false, // 税号
              Phone:false, // 电话
              Fax:false, // 传真
              ZipCode:false, // 邮编
            },
            uploading: false
        }
    },
    methods: {
        formatDate(datetime) {
            return new Date(datetime).format('yyyy-MM-dd');
        },
        save() {
            if(this.state == 0) {
                this.$refs['form'].submit();
            }
            else {
                this.cancel();
            }
        },
        beforeSave() {
            this.uploading = true;
        },
        afterSaved() {            
            this.uploading = false;
        },
        onSaved() {
            this.$message.success("保存成功");
            this.visible = false;
            this.$emit('saved');
        },
        onShow() {
            //this.visible = true;
          // 跳转
          this.$router.push({
            path:'/My/Company'
          });
        },
        cancel() {
            this.visible = false;
        },
        loadData() {
            let self = this;
            for(var i in this.formChange){
              this.formChange[i] = false;
            }
            self.$http.post(self.url.get, {
            }).then(result => {
                if (result.State == 1 && result.Data) {
                    for(var i in self.form) {
                        if(result.Data[i] !== undefined) {
                            self.form[i] = result.Data[i];
                        }
                        else {
                            self.form[i] = null;
                        }
                    }

                    self.loadCity();
                    self.form.City = result.Data.City;
                    self.loadBankBranch();
                    self.form.Account = result.Data.Account;
                    self.form.AccountBank = result.Data.AccountBank;

                    self.state = result.Data.State;
                } else {
                    for(var i in self.form) {
                        self.form[i] = null;
                    }
                }
            }, () => { });
        },
        loadProvince() {
            var self = this;
            self.$http.post(self.url.province, {}).then(result => {
                if (result.State == 1 && result.Data != null) {
                    self.formTemplate[18].options = result.Data;
                } else { 
                self.formTemplate[18].options = [];
                }
            }, () => {
            });
        },
        loadCity() {
            var self = this;
            self.form.City = null;
            self.form.AccountBank = null;
            self.$http.post(self.url.city, { Data: self.form.Province }).then(result => {
                if (result.State == 1 && result.Data != null) {
                    self.formTemplate[19].options = result.Data;
                } else {
                    self.formTemplate[19].options = [];
                }
            }, () => {
            });
        },
        loadBanks() {
            var self = this;
            self.$http.post(self.url.bank, { Data: self.form.Province }).then(result => {
                if (result.State == 1 && result.Data != null) {
                    self.formTemplate[17].options = result.Data;
                } else {
                    self.formTemplate[17].options = [];
                }
            }, () => {
            });
        },
        loadBankBranch() {
            var self = this;
            if (self.form.City != '' && self.form.City != null && self.form.Bank != '' && self.form.Bank != null) {
                self.form.AccountBank = null;
                self.$http.post(self.url.bankBranch, {
                    Data: {
                        BankId: self.form.Bank,
                        CityId: self.form.City,
                    }
                }).then(result => {
                    if (result.State == 1 && result.Data != null) {
                        self.formTemplate[20].options = result.Data;
                    } else {
                        self.formTemplate[20].options = [];
                    }
                }, () => {
                });
            }
        },
        onAccountChange(v) {
            var self = this;
            this.formChange.Account = true;
            if (v != null && v.length >= 6) {
                var s = v.substring(0, 6);
                self.$http.post(self.url.bankSearch, {
                    Data: s
                }).then(result => {
                    if (result.State == 1 && result.Data != null) {
                        self.form.Bank = result.Data.BankId;
                        self.bankIsOk = true;
                        self.loadBankBranch();
                    } else {
                        self.bankIsOk = false;
                    }
                }, () => {
                    self.bankIsOk = false;
                });
            }
        },
        onvisible() {
          if(this.$refs['form'] !== undefined){
            this.$refs['form'].clearValidate();
          }

            this.loadData();
        },

        BusinessLicenseChange(v){ // 营业执照
            this.formChange.BusinessLicense = true;
        },
        JuridicalPersonChange(v){ // 法人
          this.formChange.JuridicalPerson = true;
        },
        DutyParagraphChange(v){ // 税号
          this.formChange.DutyParagraph = true;
        },
        PhoneChange(v){ // 电话
          this.formChange.Phone = true;
        },
        FaxChange(v){ // 传真
          this.formChange.Fax = true;
        },
        ZipCodeChange(v){ // 邮编
          this.formChange.Zip = true;
        },
    },
    computed: {
        title() {
            return this.company == null ? '未认证企业' : this.company;
        },
        button() {
          return this.CompanyState == 2 ? '查看企业' :this.CompanyState == 9 || this.CompanyState === null ? '认证企业' : '审批中';
        },
        subtitle() {
            return this.company == null ? '认证企业信息之后，您可以享受企业用户相关功能' : '您现在可以享受企业用户相关功能';
        },
        isActive() {
            return this.company != null;
        }
    },
    created() {
    },
    mounted() {
        this.loadBanks();
        this.loadProvince();
    },
    watch: {
        visible(val) {
            if(val) {
                this.onvisible();
            }
        }
    }
}
</script>

<style type="text/css" scoped>

.button {
    padding: 5px 10px;
}

.types {
    overflow: hidden;
    margin-top: 30px;
}

.type-item {
    width: calc(50% - 20px);
    border: 1px solid #CCC;
    padding: 30px 10px;
    text-align: center;
    float: left;
    cursor: pointer;
}
.type-item + .type-item {
    float: right;
}
.type-item:only-child {
    float: none;
    margin:0 auto;
}

.type-item.active {
    border: 3px solid #0A529C;
}

.type-item > .icon {
    height: 150px;
    line-height: 150px;
}
.type-item:last-child > .icon {
    padding-top: 20px;
}

.type-item > h3 {
    font-weight: 700;
    line-height: 30px;
}

</style>



// WEBPACK FOOTER //
// src/views/Me/Info/components/Company.vue